// Global Digital Assistant Service
class DigitalAssistantService {
  constructor() {
    this.instance = null;
  }

  // Set the digital assistant instance
  setInstance(instance) {
    this.instance = instance;
    console.log('Digital Assistant instance set');
  }

  // Track vehicle view
  trackVehicleView(vehicleId, vehicleData) {
    if (this.instance) {
      this.instance.trackVehicleView(vehicleId, vehicleData);
    } else {
      console.warn('Digital Assistant instance not available for vehicle tracking');
    }
  }

  // Send context message to AI
  sendContextMessage(message, context = {}) {
    if (this.instance) {
      // Add context to the message
      const contextualMessage = {
        message: message,
        context: context,
        timestamp: new Date().toISOString()
      };
      
      // This would be handled by the digital assistant
      console.log('Sending contextual message:', contextualMessage);
    }
  }

  // Get current viewed vehicles
  getViewedVehicles() {
    if (this.instance) {
      return this.instance.viewedVehicles || [];
    }
    return [];
  }

  // Check if digital assistant is available
  isAvailable() {
    return this.instance !== null;
  }
}

// Create singleton instance
const digitalAssistantService = new DigitalAssistantService();

export default digitalAssistantService;
